import { GetterTree } from "vuex";
import { ISaleOrderState } from "./state";
import { ISaleOrder } from "@/models";

export const getters: GetterTree<ISaleOrderState, any> = {

    getSaleOrderById: (state) => (saleOrderId: number): ISaleOrder => {
        return state.saleOrders.find(so => so.saleOrderId === saleOrderId);
    },

};
